
<template>
  	<div class="animated fadeIn">
		<b-row>
		    <b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-cab"></i><strong> {{$trans['general']['nav_police_stations']}}</strong> <!-- <small>dropdown support</small> -->
			        </div>
			        <div>
						<b-row v-if="typeof id_item_selected === 'undefined'">
							<b-col md="12">
								<b-row>
									<b-col lg="6" class="p-0">
										<b-col md="12">
											<!-- <label for="choose-item">Escolher Concelho</label> -->
											<b-form-group :label="$trans[$route.meta.trans_key]['county']" label-for="sel-county">
												<b-form-select id="choose-item" v-model="id_item_selected">
													<option :value="undefined">{{$trans[$route.meta.trans_key]['all_counties']}}</option>
													<option v-for="item in counties" :key="item.id" :value="item.id">{{item.name}}, {{item.district.name}}</option>
												</b-form-select>
											</b-form-group>
										</b-col>
										<b-col md="12">
											<b-form-group :label="$trans[$route.meta.trans_key]['search_county']" :label-for="search1.id">
												<autosuggest v-bind:input="search1" v-bind:key_compare="'name'" v-bind:show="!loading1" v-bind:items="counties" v-on:choose-item="choose_item_search1"></autosuggest>
											</b-form-group>
										</b-col>
									</b-col>
									<b-col lg="6">
										<!-- <b-form-select class="opacity-0 pointer-events-none">
											<option></option>
										</b-form-select> -->
										<b-form-group label="hidden-inp" class="invisible d-lg-block d-none">
											<b-form-select>
												<option></option>
											</b-form-select>
										</b-form-group>
										<div>
											<b-form-group :label="$trans[$route.meta.trans_key]['map_style']" label-for="sel-map-style">
												<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
													<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
												</b-form-select>
											</b-form-group>
										</div>
									</b-col>
								</b-row>
								<b-col md="12" class="p-0">
									<b-tabs pills v-model="tab_idx" class="text-capitalize">
										<b-tab :title="(maps_data1 != null && typeof maps_data1.map_data.markers !== 'undefined') ? 'GNR (' +maps_data1.map_data.markers.length+ ')' : 'GNR'">
											<b-col md="12" class="card-loader-container p-0">
												<loader v-if="loading1"></loader>
												<div v-else>
													<div class="loader-wrapper">
														<loader v-if="loading1"></loader>
										    			<l-map-wrapper v-bind:data="maps_data1" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:func_setMarkerInfo="setMarkerInfo" v-bind:mapType="'markerCluster'" class="my-map-leaflet"></l-map-wrapper>
													</div>
												</div>
											</b-col>
										</b-tab>
										<b-tab :title="(maps_data2 != null && typeof maps_data2.map_data.markers !== 'undefined') ? 'PSP (' +maps_data2.map_data.markers.length+ ')' : 'PSP'">
											<b-col md="12" class="card-loader-container p-0">
												<loader v-if="loading1"></loader>
												<div v-else>
													<div class="loader-wrapper">
														<loader v-if="loading2"></loader>
										    			<l-map-wrapper v-if="load_map2" v-bind:data="maps_data2" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:func_setMarkerInfo="setMarkerInfo" v-bind:mapType="'markerCluster'" class="my-map-leaflet"></l-map-wrapper>
													</div>
												</div>
											</b-col>
										</b-tab>
									</b-tabs>
								</b-col>
							</b-col>
						</b-row>






						<b-row v-else>
							<b-col lg="6">
								<b-col sm="12" class="p-0">
									<b-form-group :label="$trans[$route.meta.trans_key]['county']" label-for="sel-county">
										<b-form-select id="choose-item" v-model="id_item_selected">
											<option :value="undefined">{{$trans[$route.meta.trans_key]['all_counties']}}</option>
											<option v-for="item in counties" :key="item.id" :value="item.id">{{item.name}}, {{item.district.name}}</option>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col sm="12" class="p-0">
									<b-form-group :label="$trans[$route.meta.trans_key]['search_county']" :label-for="search1.id">
										<autosuggest v-bind:input="search1" v-bind:key_compare="'name'" v-bind:show="!loading1" v-bind:items="counties" v-on:choose-item="choose_item_search1"></autosuggest>
									</b-form-group>
								</b-col>
								<b-row>
									<b-col md="12">
										<b-tabs pills v-model="tab_idx">
											<b-tab :title="'GNR (' +items1.length+ ')'" v-on:click="tab_idx = 0">
												<b-col md="12" class="card-loader-container p-0">
													<loader v-if="loading1"></loader>
													<div v-else-if="items1.length === 0">
														<h6>{{$trans[$route.meta.trans_key]['no_results']}}</h6>
													</div>
													<div v-else>
														<div class="d-lg-none d-block">
															<b-list-group class="mobile-list">
	 															<b-list-group-item class="cursor-pointer" v-on:click.prevent="change_item1(item)" v-for="(item, key) in items1" :key="key">{{item.unidade}}</b-list-group-item>
															</b-list-group>
														</div>
														<div class="list-group d-lg-block d-none">
															<div v-on:click.prevent="change_item1(item)" v-for="(item, key) in items1" :key="key">
																<b-btn v-b-toggle="'item_'+key" :class="(opened1_item && item1_selected.id == item.id) ? 'active' : ''" :aria-controls="'item1_'+key" :aria-expanded="(opened1_item && item1_selected.id == item.id) ? 'true' : 'false'" class="white-space-normal list-group-item list-group-item-action">{{item.unidade}}</b-btn>
		  														<b-collapse class="p-3" :id="'item1_'+key" :visible="opened1_item && item1_selected.id == item.id">
																	<div v-on:click.stop="">
																		<p><b>Unidade</b>: {{item.unidade}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['address']}}</b>: {{item.address}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['district']}}</b>: <router-link :to="base_url+ '/div-admin/distritos/' +county_selected.district.id"> {{county_selected.district.name}}</router-link></p>
																		<p><b>{{$trans[$route.meta.trans_key]['county']}}</b>: <router-link :to="base_url+ '/div-admin/concelhos/' +id_item_selected"> {{county_selected.name}}</router-link>
																		</p>
																		<p><b>Email</b>: <a :href="'mailto:' +item.email">{{item.email}}</a></p>
																		<p><b>Telefone</b>: {{item.phone}}</p>
																		<p><b>Latitude</b>: {{item.latitude}}</p>
																		<p><b>Longitude</b>: {{item.longitude}}</p>
		   															</div>
																</b-collapse>
															</div>
														</div>
													</div>
												</b-col>
											</b-tab>
											<b-tab :title="'PSP (' +items2.length+ ')'" v-on:click="tab_idx = 1">
												<b-col md="12" class="card-loader-container p-0">
													<loader v-if="loading2"></loader>
													<div v-else-if="items2.length === 0">
														<h6>{{$trans[$route.meta.trans_key]['no_results']}}</h6>
													</div>
													<div v-else>
														<div class="d-lg-none d-block">
															<b-list-group class="mobile-list">
																<b-list-group-item class="cursor-pointer" v-on:click.prevent="change_item2(item)" v-for="(item, key) in items2" :key="key">{{item.unidade}}</b-list-group-item>
															</b-list-group>
														</div>
														<div class="list-group d-lg-block d-none">
															<div v-on:click.prevent="change_item2(item)" v-for="(item, key) in items2" :key="key">
																<b-btn v-b-toggle="'item_'+key" :class="(opened2_item && item2_selected.id == item.id) ? 'active' : ''" :aria-controls="'item2_'+key" :aria-expanded="(opened2_item && item2_selected.id == item.id) ? 'true' : 'false'" class="white-space-normal list-group-item list-group-item-action">{{item.unidade}}</b-btn>
		  														<b-collapse class="p-3" :id="'item2_'+key" :visible="opened2_item && item2_selected.id == item.id">
																	<div v-on:click.stop="">
																		<p><b>Unidade</b>: {{item.unidade}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['address']}}</b>: {{item.address}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['district']}}</b>: <router-link :to="base_url+ '/div-admin/distritos/' +county_selected.district.id"> {{county_selected.district.name}}</router-link></p>
																		<p><b>{{$trans[$route.meta.trans_key]['county']}}</b>: <router-link :to="base_url+ '/div-admin/concelhos/' +id_item_selected"> {{county_selected.name}}</router-link>
																		</p>
																		<p><b>Email</b>: <a :href="'mailto:' +item.email">{{item.email}}</a></p>
																		<p><b>Telefone</b>: {{item.phone}}</p>
																		<p><b>Latitude</b>: {{item.latitude}}</p>
																		<p><b>Longitude</b>: {{item.longitude}}</p>
		   															</div>
																</b-collapse>
															</div>
														</div>
													</div>
												</b-col>
											</b-tab>
										</b-tabs>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="6" v-if="!is_mobile()">
								<b-col md="12" class="p-0">
									<b-form-group label="hidden-inp" class="invisible d-lg-block d-none">
										<b-form-select>
											<option></option>
										</b-form-select>
									</b-form-group>
									<b-form-group :label="$trans[$route.meta.trans_key]['map_style']" label-for="sel-map-style">
										<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
											<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col md="12" class="p-0">
									<b-tabs pills v-model="tab_idx" class="text-capitalize">
										<b-tab :title="$trans[$route.meta.trans_key]['map']+ ' GNR'">
											<div class="loader-wrapper text-transform-none">
												<loader v-if="loading1"></loader>
												<h5 v-else-if="item1_selected === null" class="select_text align-center">{{$trans[$route.meta.trans_key]['select_result_box']}}</h5>
								    			<l-map-wrapper v-else-if="maps_data1 != null && item1_selected !== null" v-bind:data="maps_data1" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:func_setMarkerInfo="setMarkerInfo" v-bind:mapType="'markerCluster'" class="my-map-leaflet"></l-map-wrapper>
											</div>
										</b-tab>
										<b-tab :title="$trans[$route.meta.trans_key]['map']+ ' PSP'">
											<div class="loader-wrapper text-transform-none">
												<loader v-if="loading2"></loader>
								    			<h5 v-else-if="item2_selected === null" class="select_text align-center">{{$trans[$route.meta.trans_key]['select_result_box']}}</h5>
								    			<l-map-wrapper v-else-if="maps_data2 != null && item2_selected !== null" v-bind:data="maps_data2" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:func_setMarkerInfo="setMarkerInfo" v-bind:mapType="'markerCluster'" class="my-map-leaflet"></l-map-wrapper>
											</div>
										</b-tab>
									</b-tabs>
								</b-col>
							</b-col>
						</b-row>
			        </div>
			    </b-card>
			</b-col>
		</b-row>
		<div v-if="is_mobile()" class="d-lg-none d-block">
			<modal v-if="item1_selected !== null" v-on:close="item1_selected = null">
				<div slot="header"><h6>{{item1_selected.unidade}}</h6>
				</div> 
				<div slot="body">
					<div class="min-height-45">
						<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
							<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
						</b-form-select>
					</div>
					<l-map-wrapper v-if="maps_data1 != null" v-bind:data="maps_data1" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:func_setMarkerInfo="setMarkerInfo" v-bind:mapType="'markerCluster'" class="my-map-leaflet map-modal"></l-map-wrapper>

					<b-list-group class="mobile-list">
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['name']}}</b>: {{item1_selected.unidade}}</b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['address']}}</b>: {{item1_selected.address}}</b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['district']}}</b>: <router-link :to="base_url+ '/div-admin/distritos/' +county_selected.district.id"> {{county_selected.district.name}}</router-link></b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['county']}}</b>: <router-link :to="base_url+ '/div-admin/concelhos/' +id_item_selected"> {{county_selected.name}}</router-link>
						</b-list-group-item>
						<b-list-group-item><b>Email</b>: <a :href="'mailto:' +item1_selected.email">{{item1_selected.email}}</a></b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['phone']}}</b>: {{item1_selected.phone}}</b-list-group-item>
						<b-list-group-item><b>Latitude</b>: {{item1_selected.latitude}}</b-list-group-item>
						<b-list-group-item><b>Longitude</b>: {{item1_selected.longitude}}</b-list-group-item>
					</b-list-group>
				</div>
			</modal>
			<modal v-if="item2_selected !== null" v-on:close="item2_selected = null">
				<div slot="header"><h6>{{item2_selected.unidade}}</h6>
				</div>
				<div slot="body">
					<div class="min-height-45">
						<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
							<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
						</b-form-select>
					</div>
					<l-map-wrapper v-if="maps_data2 != null" v-bind:data="maps_data2" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:func_setMarkerInfo="setMarkerInfo" v-bind:mapType="'markerCluster'" class="my-map-leaflet map-modal"></l-map-wrapper>

					<b-list-group class="mobile-list">
						<b-list-group-item><b>Unidade</b>: {{item2_selected.unidade}}</b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['address']}}</b>: {{item2_selected.address}}</b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['district']}}</b>: <router-link :to="base_url+ '/div-admin/distritos/' +county_selected.district.id"> {{county_selected.district.name}}</router-link></b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['county']}}</b>: <router-link :to="base_url+ '/div-admin/concelhos/' +id_item_selected"> {{county_selected.name}}</router-link>
						</b-list-group-item>
						<b-list-group-item><b>Email</b>: <a :href="'mailto:' +item2_selected.email">{{item2_selected.email}}</a></b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['phone']}}</b>: {{item2_selected.phone}}</b-list-group-item>
						<b-list-group-item><b>Latitude</b>: {{item2_selected.latitude}}</b-list-group-item>
						<b-list-group-item><b>Longitude</b>: {{item2_selected.longitude}}</b-list-group-item>
					</b-list-group>
				</div>
			</modal>
		</div>
	</div>
</template>

<script>
import LMapWrapper from '@/views/sub_components/LMapWrapper';

export default {
	name: 'Police_Stations',
	components: {
		LMapWrapper
	},
	data() {
		return {
			items1: [],
			items2: [],
			loading1: true,
			loading2: true,
			opened1_item: false,
			opened2_item: false,
			tab_idx: 0,
			load_map2: false, // avoid render bugs
			counties: [],
			id_item_selected: null,
			county_selected: null,
			search1: {
				id: 'search-county',
				value: '',
				has_error: false,
				placeholder: this.$trans[this.$route.meta.trans_key]['county'],
				error: this.$trans[this.$route.meta.trans_key]['county']+ ' não encontrado'
			},
			item1_selected: null,
			item2_selected: null,
			maps_data1: null,
			maps_data2: null,
			map: {style: null, styles: []}
		}
	},
	methods: {
		get_items_gnr: function(url) {
			const that = this;
			that.get_req(url,
				function() { // before
					that.loading1 = true;
					/*that.loading2 = false;*/
	            },
				function(response) { // success
					that.maps_data1 = response.body.data.map;
					that.items1 = response.body.data.items;
					that.loading1 = false;
					/*that.loading2 = false;*/
					
				},
				function(response) { // fail
					that.loading1 = false;
				},
				function(response) {
					
				}
			);
		},
		get_items_psp: function(url) {
			const that = this;
			that.get_req(url,
				function() { // before
					that.loading2 = true;
					/*that.loading2 = false;*/
	            },
				function(response) { // success
					that.maps_data2 = response.body.data.map;
					that.items2 = response.body.data.items;
					that.loading2 = false;
					
				},
				function(response) { // fail
					that.loading2 = false;
				},
				function(response) {
					
				});
		},
		change_item1: function(item) {
			if(this.item1_selected === item) {
				this.item1_selected = null;
				return;
			}
			this.item1_selected = item;
			this.maps_data1.map_data.markers = [item]
			this.maps_data1.map_data.longitude = item.longitude;
			this.maps_data1.map_data.latitude = item.latitude;
		},
		change_item2: function(item) {
			if(this.item2_selected === item) {
				this.item2_selected = null;
				return;
			}
			this.item2_selected = item;
			this.maps_data2.map_data.markers = [item]
			this.maps_data2.map_data.longitude = item.longitude;
			this.maps_data2.map_data.latitude = item.latitude;
		},
		do_search1: function() {
			if(this.search1.value.trim() !== '') {
				var item_selected_tmp = this.counties.find((item, idx) => item.name == this.search1.value || item.name.toLowerCase() == this.search1.value.toLowerCase());
				if(typeof item_selected_tmp === 'undefined') {
					this.search1.has_error = true;
					return;
				}
				this.id_item_selected = item_selected_tmp.id;
				this.search1.has_error = false;
			}
		},
		setMapStyles: function(styles) {
			this.map.styles = styles;
			if(this.map.style === null)
				this.map.style = styles[0];
		},
		setMarkerInfo: function(item) {
			return '<p style="font-weight: bold;margin:0;">' +item.unidade+ '</p><p style="margin:0;"><b>' +this.$trans[this.$route.meta.trans_key]['address']+ ':</b> ' +item.address+ '<br><b>' +this.$trans[this.$route.meta.trans_key]['phone']+ ':</b> ' +item.phone+ '<br><b>Email:</b> <a href="mailto:' +item.email+ '">' +item.email+ '</a></p>';
		}
	},
	watch: {
		/*len_items: function(new_val, old_val) {
			if(new_val === 0) {
				this.item_selected = null;
			}
		},*/
		tab_idx: function(new_val, old_val) {
			if(new_val == 1 && !this.load_map2) {
				this.load_map2 = true;
			}
		},
		id_item_selected: function(new_val, old_val) {
			this.item1_selected = null;
			this.item2_selected = null;
			this.search1.value = '';
			if(typeof new_val === 'undefined') {
				this.items1 = []; // no waiting for the response
				this.items2 = [];
				this.county_selected = null;
				this.get_items_gnr('police-stations/gnr');
				this.get_items_psp('police-stations/psp');
				return;
			}
			this.county_selected = this.counties.find((item, key) => item.id == new_val);
			this.get_items_gnr('police-stations/gnr/' +new_val);
			this.get_items_psp('police-stations/psp/' +new_val);
			
		},
		item1_selected: function(new_val, old_val) {
			this.opened1_item = new_val != null;
		},
		item2_selected: function(new_val, old_val) {
			this.opened2_item = new_val != null;
		},
		'$route.params.id_county': function(new_val, old_val) {
			if(this.id_item_selected != new_val) {
				this.id_item_selected = new_val;
			}
		},
		loading1: function(new_val, old_val) {
			if(!new_val) {
				let params = this.$route.params;
				if(this.county_selected !== null) {
					params.id_county = this.id_item_selected;
					params.slug = this.county_selected.slug;
				}
				else {
					params = {lang: this.$lang};
				}
				this.$router.push({name: 'Police_Stations', params: params});
			}
		},
	},
	computed: {

	},
	created: function() {
		this.id_item_selected = this.$route.params.id_county;
		if(this.globs['police_sta_counties'] !== null) {
			this.counties = this.globs['police_sta_counties'];
			if(typeof this.id_item_selected === 'undefined') {
				this.get_items_gnr('police-stations/gnr');
				this.get_items_psp('police-stations/psp');
				return;
			}
			this.id_item_selected = this.get_starter_item(this.globs['police_sta_counties'], this.id_item_selected).id;
			return;
		}
		const that = this;
		that.get_req('police-stations/counties',
			function() { // before
				//that.loading = true;
            },
			function(response) { // success
				that.counties = response.body;
				that.globs['police_sta_counties'] = that.counties;
				if(typeof that.id_item_selected == 'undefined') {
					that.get_items_gnr('police-stations/gnr');
					that.get_items_psp('police-stations/psp');
				}
				else {
					that.id_item_selected = that.get_starter_item(that.counties, that.id_item_selected).id;
				}
			},
			function(response) { // fail
				alert('ajax main.js error: '+ response.status);
			},
			function(response) {
				
			});
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
<style>
	
</style>